import { Map } from 'immutable'
import _toString from 'lodash/toString'
import { delay as wait } from 'bluebird'
import {
  SET_INBOUND_TRACKING_DATA,
} from '../inbound-tracking/actions'
import { containsEverflowTrackingQueryVars } from '../inbound-tracking/index'
import {
  getEverFlowScript,
} from '.'

/**
 * Determines whether EverFlow tracking should be triggered based on current state.
 *
 * This function checks if the current page contains EverFlow tracking query parameters
 * that indicate the user came from an EverFlow affiliate link. It's used as a condition
 * to determine when to fire EverFlow tracking events.
 *
 * @param {Object} params - The parameters object
 * @param {Object} params.state - The Redux state object
 * @param {Map} params.state.resolver - The resolver state containing query parameters
 * @returns {Boolean} True if EverFlow tracking should trigger, false otherwise
 *
 * @example
 * // Used as a condition in Redux watchers
 * .when(everflowTrackingShouldTrigger)
 */
function everflowTrackingShouldTrigger ({ state }) {
  const { resolver } = state
  const query = resolver.get('query') || Map()

  return (
    containsEverflowTrackingQueryVars(query)
  )
}

/* eslint-disable import/prefer-default-export */
export function watchEverFlowTrackingData ({ after }) {
  return after([
    SET_INBOUND_TRACKING_DATA,
  ], async ({ action }) => {
    const { payload } = action
    const payloadAffid = payload?.data.get('affiliateId') ? _toString(payload.data.get('affiliateId')) : undefined
    const payloadOid = payload?.data.get('offerId') ? _toString(payload.data.get('offerId')) : undefined

    if (!payloadAffid || !payloadOid) {
      return
    }

    // load the EverFlow SDK
    await getEverFlowScript()
    const { EF } = global

    if (EF) {
      // Small delay to ensure all everflow internal listeners are attached
      await wait(100)

      // fire the click event
      EF.click({
        offer_id: payloadOid,
        affiliate_id: payloadAffid,
      })
    }
  })
    .when(everflowTrackingShouldTrigger)
}
